import Icon from "@mui/material/Icon"
import MDBox from "components/MDBox"
import MDTypography from "components/MDTypography"
import { Card } from "../ui/Page"
import { useRefined } from "../ui/refined"

// White rounded card with subtle shadow, a bold navy title and an optional
// blue circular icon chip + right-aligned action — the Home/Budget card style.
const SectionCard = ({
  title,
  subtitle,
  icon,
  eyebrow,
  action,
  children,
  p = { xs: 2, sm: 2.5, md: 3 },
  mb = 3,
}) => {
  const refined = useRefined()
  if (refined) {
    // Same props, refined chrome: one hairline-headed card (see pageRefined.css).
    return (
      <Card
        icon={icon ? <Icon>{icon}</Icon> : undefined}
        title={
          eyebrow ? (
            <>
              <span className="pc-card-eyebrow">{eyebrow}</span>
              {title}
            </>
          ) : (
            title
          )
        }
        subtitle={subtitle}
        action={action}
        style={{ marginBottom: mb * 8 }}
      >
        {children}
      </Card>
    )
  }
  return (
  <MDBox bgColor="white" borderRadius="lg" shadow="sm" p={p} mb={mb}>
    {(title || action || icon) && (
      <MDBox
        display="flex"
        justifyContent="space-between"
        alignItems={{ xs: "flex-start", sm: "center" }}
        flexWrap="wrap"
        gap={1.5}
        mb={children ? 2.5 : 0}
      >
        <MDBox
          display="flex"
          alignItems="center"
          gap={1.5}
          sx={{ minWidth: 0, flex: "1 1 260px" }}
        >
          {icon && (
            <MDBox
              width="2.5rem"
              height="2.5rem"
              minWidth="2.5rem"
              borderRadius="50%"
              bgColor="info"
              color="white"
              display="flex"
              alignItems="center"
              justifyContent="center"
              shadow="md"
            >
              <Icon fontSize="small">{icon}</Icon>
            </MDBox>
          )}
          <MDBox sx={{ minWidth: 0 }}>
            {eyebrow && (
              <MDTypography
                variant="caption"
                color="info"
                fontWeight="bold"
                display="block"
                sx={{ textTransform: "uppercase", letterSpacing: "0.5px" }}
              >
                {eyebrow}
              </MDTypography>
            )}
            {title && (
              <MDTypography
                variant="h6"
                fontWeight="bold"
                sx={{ lineHeight: 1.35, wordBreak: "break-word" }}
              >
                {title}
              </MDTypography>
            )}
            {subtitle && (
              <MDTypography
                variant="caption"
                color="text"
                display="block"
                sx={{ lineHeight: 1.4, mt: 0.25 }}
              >
                {subtitle}
              </MDTypography>
            )}
          </MDBox>
        </MDBox>
        {action}
      </MDBox>
    )}
    {children}
  </MDBox>
  )
}

export default SectionCard
